import { render, staticRenderFns } from "./PublicationProgress.vue?vue&type=template&id=dd2f9b5c"
import script from "./PublicationProgress.vue?vue&type=script&lang=js"
export * from "./PublicationProgress.vue?vue&type=script&lang=js"
import style0 from "./PublicationProgress.vue?vue&type=style&index=0&id=dd2f9b5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports